// import { Alert } from "components/Alert/Alert";
// import { useLangContext } from "components/Lang/Lang";
// import { Loading } from "components/Loading/Loading";
// import {  Geometry, GeometryTypes } from "components/ThreeItems/Geometry/Geometry";
// import { SceneItemsType } from "components/ThreeItems/Scene";
import { Geometry } from "components/ThreeItems/Geometry/Geometry";
import { useLangContext } from "context/Lang";
import { ToastMessage } from "primereact/toast";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate,  useSearchParams } from "react-router-dom";
import { routes } from "routes";
import { AsyncProcess } from "services/AsyncProcess";
import { setToast } from "storeRedux/slices/toast";
import * as THREE from "three"
import { ReplaceWords } from "utils/ReplaceWords";
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
// import { ColorsType, ObjectType } from "types";
// import { CategoriObjectProps,  MapItemProps, MaterialTypeProps } from "types/three";
// import { rgbToHex } from "utils/rgbToHex";
import { StringJSONPRS } from "utils/StringJsonPRS";






type meshFunProcess = ({ ...e }: { mesh: THREE.Object3D, copy?: boolean, effect?: () => void }) => void




export interface MapEditorContextProps {

    addMesh?: ({ mesh,Object }: { mesh?: MeshProps,Object?:THREE.Object3D }) => void,
    mapEditorId?:number|string

    activeThreeItems?:ActiveBuildingItem[]
    setActiveThreeItems?:React.Dispatch<React.SetStateAction<ActiveBuildingItem[]>>,
    getActiveThreeItems?:()=>void

    handleSave?: meshFunProcess,
    handleUpdate?: meshFunProcess,
    handleDelete?: meshFunProcess,


    threeItems?:MapItem[]|null 
    setThreeItems?: React.Dispatch<React.SetStateAction<MapItem[] | null>>
    selectThreeItem?: THREE.Object3D | null
    setSelectThreeItem?: React.Dispatch<React.SetStateAction<THREE.Object3D | null>>

    sceneItemsRef?: React.RefObject<SceneItemsProps | undefined>
    handleLoadScene?: (e: SceneItemsProps) => void
    getMeshesOfBuilding?:(e?:{editorId?:number,onGetData?:(res:any)=>void,onError?:(err:string)=>void})=>void,
    getItemsOfMap?:(e?:{onGetData?:(res:any)=>void,onError?:(err:string)=>void})=>void,
    loadMeshes?:(meshes?: MeshProps[],onGetObject?:({object}:{object:THREE.Object3D})=>void)=>void

    loadMapItems?:(e?:{items?:MapItem[],group?:THREE.Group})=>void

    // handleLoadScene?:({...e}:SceneItemsType)=>void


    // materials?:MaterialTypeProps[]|null
    // setMaterials?:React.Dispatch<React.SetStateAction<MaterialTypeProps[]|null>>

    // selectMaterial?:MaterialTypeProps|null
    // setSelectMaterial?:React.Dispatch<React.SetStateAction<MaterialTypeProps|null>>



}


const MapEditorContext = createContext<MapEditorContextProps>({});


type EditorProviderProps = {
    onDataLoad?: (e?: any) => void,
    children: any,
    // editorId?: number
    mapEditorId?:number|string
}

export const MapEditorProvider = ({ ...props }: EditorProviderProps) => {



    // const [alert,setAlert]=useState<{color?:ColorsType,message:string}|null>(null);


    const sceneItemsRef = useRef<SceneItemsProps | undefined>(undefined);

    const { gW } = useLangContext();

    
    const [activeThreeItems,setActiveThreeItems] = useState<ActiveBuildingItem[]>([]);
    
    const [selectThreeItem, setSelectThreeItem] = useState<THREE.Object3D | null>(null);

    const [threeItems,setThreeItems] = useState<MapItem[]|null>(null);

    // const [cards,setCards]=useState<CategoriObjectProps[]|null>(null);
    // const [category,setCategory]=useState<CategoriObjectProps[]|null>(null);

    const [searchParams] = useSearchParams();

    const mapEditorId = props?.mapEditorId || searchParams.get("mapEditorId");

    const [block, setBlock] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const [materials,setMaterials]=useState<MaterialTypeProps[]|null>(null);
    // const [selectMaterial,setSelectMaterial]=useState<MaterialTypeProps|null>(null);


    const getActiveThreeItems=()=>{
        AsyncProcess({    
            type:"get",
            url:routes.api.threeItemEditor+"/active-items",
            setError:()=>{
    
            },
            effectProcess:[(res)=>{
                if(res?.success!==false){
                    setActiveThreeItems(res?.data)
                }
            }]
        })
    }


    const getMeshesOfBuilding=(e?:{editorId?:number,onGetData?:(res:any)=>void,onError?:(err:string)=>void}):void=>  {

        AsyncProcess({
            type:"get",
            url: ReplaceWords(routes.api.meshesByThreeItemEditor,{id:e?.editorId}),
            setError:()=>{
                e?.onError?.("error");
            },
            effectProcess:[(res)=>{
                if(res?.success!==false){
                    e?.onGetData?.(res?.data)
                }else {
                    e?.onError?.( res?.message||"error");

                }
            }]
        })

    }


    const getItemsOfMap=(e?:{onGetData?:(res:any)=>void,onError?:(err:string)=>void}):void=>  {

        AsyncProcess({
            type:"get",
            url: ReplaceWords(routes.api.itemsOfMap,{id:mapEditorId}),
            setError:()=>{
                e?.onError?.("error");
            },
            effectProcess:[(res)=>{
                if(res?.success!==false){
                    e?.onGetData?.(res?.data)
                }else {
                    e?.onError?.( res?.message||"error");

                }
            }]
        })

    }





    const addMesh = ({ mesh, Object }: { mesh?: MeshProps,Object?:THREE.Object3D }): void => {

            const tempMesh = new THREE.Mesh();

            const a = mesh?.type;
            const prs = mesh?.prs ? StringJSONPRS({ data: mesh?.prs + "" }) as ObjectType<any> : {}

            const [px, py, pz] = prs.position || [0, 0, 0];
            tempMesh.position.set(px, py, pz);

            const [rx, ry, rz] = prs.rotation || [0, 0, 0];
            tempMesh.rotation.set(rx, ry, rz);

            const [sx, sy, sz] = prs.scale || [1, 1, 1];
            tempMesh.scale.set(sx, sy, sz);


            if (tempMesh.userData) {
                tempMesh.userData.id = mesh?.id;
                tempMesh.userData.materialId = mesh?.material?.id;
                tempMesh.userData.image = mesh?.imageUrl;
            }






            const tempGeometry = Geometry({
                type: a,
                radialSegments: mesh?.radialSegments,
                parameters: mesh?.parameters,
                material: {
                    color: mesh?.color,
                    imageUrl: mesh?.material?.imageUrl as string || null,
                    opacity: Number(mesh?.opacity || 1)
                }
            });



            tempMesh.name = mesh?.name || "";

            tempMesh.userData.type = a;
            tempMesh.userData.imageUrl = mesh?.material?.imageUrl;
            tempMesh.userData.materialId = mesh?.material?.id;
            tempMesh.userData.params =  mesh?.parameters;


            tempMesh.geometry = tempGeometry.mesh.geometry;
            tempMesh.material = tempGeometry.mesh.material;


            // tempMesh.add(tempGeometry.mesh);

            tempMesh.updateMatrix();

            Object?.add(tempMesh);            

            // sceneItemsRef?.current?.scene_group?.add?.(tempMesh);
        


    }



    
    
    const loadMapItems=(e?:{items?:MapItem[],group?:THREE.Group})=>{
        if(e?.group?.children?.length===0){
            e?.items?.forEach(item=>{
                loadMeshes?.(item?.building?.activeEditor?.meshes,(obj)=>{


                    obj.object.userData.id = item?.id
                    obj.object.userData.buildingTitle = item?.building?.title;

                    obj.object.name = item?.building?.unitName||"";
                    
                    const prs = item?.prs ? StringJSONPRS({ data: item?.prs + "" }) as any : {};
                    const [px, py, pz] = prs.position || [0, 0, 0];
                    obj.object.position.set(px, py, pz);
            
                    const [rx, ry, rz] = prs.rotation || [0, 0, 0];
                    obj.object.rotation.set(rx, ry, rz);
            
                    const [sx, sy, sz] = prs.scale || [1, 1, 1];
                    obj.object.scale.set(sx, sy, sz);

                    if (item?.building?.title) {
                        const labelDiv = document.createElement('div');
                        labelDiv.className = 'building-label';
                        labelDiv.textContent = item.building.title;
                        
                        labelDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.75)';
                        labelDiv.style.color = '#white';
                        labelDiv.style.padding = '4px 8px';
                        labelDiv.style.borderRadius = '4px';
                        labelDiv.style.fontSize = '12px';
                        labelDiv.style.pointerEvents = 'none'; 
                        labelDiv.style.whiteSpace = 'nowrap';

                        const labelObject = new CSS2DObject(labelDiv);
                        
                        labelObject.position.set(0, 20, 0); 
                        
                        obj.object.add(labelObject);
                    }

                    e?.group?.children.push(obj.object);
                    e?.group?.updateMatrix()


                })

            }) 
        }
        
    }





    const loadMeshes = (meshes?: MeshProps[],onGetObject?:({object}:{object:THREE.Object3D})=>void) => {
        if (sceneItemsRef?.current?.scene_group && meshes) {
            const object = new THREE.Object3D;

            meshes?.forEach(mesh => {
                addMesh?.({ mesh, Object:object  });
            })

            object.updateMatrix();
            onGetObject?.({object});

            props.onDataLoad?.();
        }
    }


    // useEffect(()=>{
    //     setMeshes([]);
    //     return ()=>{
    //         setMeshes([]);
    //     }
    // },[pathname]);


    const handleLoadScene = (e: SceneItemsProps): void => {

        
        sceneItemsRef.current = e;
        loadMapItems({items:threeItems||[], group:sceneItemsRef.current.scene_group });
        // loadMeshes(meshes);

    }



    // const getMaterials=()=>{
    //     setBlock(true);   
    //     AsyncProcess({
    //         type:"get",
    //         url:routes.api.material,
    //         setError:(err)=>{
    //             setAlert({message:gW(err?.error||"happen-error"),color:"red"})
    //             setBlock(false);
    //         },
    //         effectProcess:[(res)=>{
    //             setMaterials(res.map((r:any)=>({...r,image: r?.image?(process.env.REACT_APP_API_URL||"")+r?.image:""})));    
    //             setBlock(false);
    //         }]
    //     });



    // }


    // const getObjects = () => {


    //     if (editorId) {

    //         if (sceneItemsRef.current?.scene_group) {
    //             setSelectMesh(null);
    //             sceneItemsRef.current.scene_group.children = []

    //         }

    //         setBlock(true);

    //         AsyncProcess({
    //             type: "get",
    //             url: ReplaceWords(routes.api.meshesByThreeItemEditor, { id: editorId }),

    //             setError: (e) => {
    //                 dispatch(setToast({ severity: "error", detail: gW("happen-error") } as ToastMessage))
    //                 setBlock(false);
    //             },
    //             effectProcess: [(res) => {

    //                 if (res?.success === false) {
    //                     dispatch(setToast({ severity: "error", detail: gW(res?.message||"happen-error") } as ToastMessage))


    //                 } else {
    //                     const m = res?.data;
    //                     setMeshes?.(m);
    //                     loadMeshes(m)

    //                 }
    //                 setBlock(false)
    //             }]
    //         })
    //     }
    // }





    useEffect(() => {
        // if (editorId) {
        // }
    }, [])


    const doSave = (mesh: THREE.Object3D, effect?: () => void) => {



        const data = {
            buildingId: mesh?.userData?.buildingId,
            prs: StringJSONPRS({ data: mesh }),
            // opacity: ((mesh as THREE.Mesh).material as THREE.MeshPhysicalMaterial).opacity,
            // parameters: JSON.stringify(((mesh as THREE.Mesh).geometry as any)?.parameters || {}),
            // materialId: mesh.userData?.materialId,
            mapEditorId: mapEditorId
            // objectid: objectid
        }

        setBlock(true);

        AsyncProcess({
            type: "post",
            data: data,
            url: routes.api.mapItems,
            setError: (e) => {
                dispatch(setToast({ severity: "error", detail: gW("happen-error") } as ToastMessage))
                setBlock(false);
            },
            effectProcess: [(res) => {

                if (res?.success === false) {
                    dispatch(setToast({ severity: "error", detail: gW(res?.message || "happen-error") } as ToastMessage))
                } else {
                    if (res?.data?.id) {
                        setSelectThreeItem(null);
                        mesh.userData = { ...mesh.userData, id: res?.data?.id }
                        effect?.();
                    } else {

                    }
                }
                setBlock(false)
            }]
        });
    }

    const handleSave: meshFunProcess = ({ mesh, copy, effect }) => {



        if (copy && mesh.userData?.id) {

            handleUpdate({
                mesh, effect: () => {
                    effect?.();
                    if (false) {
                        setTimeout(() => {
                            delete mesh.userData.id;
                            sceneItemsRef.current?.scene_group?.add(mesh);
                            setSelectThreeItem(mesh);
                        }, 10);
                    }
                }
            })
        } else {
            doSave(mesh, false ? () => {
                setTimeout(() => {
                    delete mesh.userData.id;
                    sceneItemsRef.current?.scene_group?.add(mesh);
                    setSelectThreeItem(mesh);
                }, 10);
            } : undefined);
        }









    }


    const handleUpdate: meshFunProcess = ({ mesh, effect }) => {



        
        const data = {
            prs: StringJSONPRS({ data: mesh }),
        }

        AsyncProcess({
            type: "post",
            data: data,
            url: ReplaceWords(routes.api.itemsOfMap,{id:mesh.userData.id}) ,
            setError: (e) => {
                dispatch(setToast({ severity: "error", detail: gW("happen-error") } as ToastMessage))

                setBlock(false);
            },
            effectProcess: [(res) => {

                if (res?.success === false) {
                    dispatch(setToast({ severity: "error", detail: gW(res?.message || "happen-error") } as ToastMessage))
                } else {
                    effect?.();
                    if (res?.data?.id) {
                        setSelectThreeItem(null);
                        effect?.();
                    } else {

                    }
                }
                setSelectThreeItem(null);
                setBlock(false)
            }]
        });

    }




    const handleDelete: meshFunProcess = ({ mesh, effect }) => {
        
        if (mesh?.userData?.id) {
            setBlock(true);
            AsyncProcess({
                type: "post",
                url: routes.api.mapItems + "/delete/" + mesh?.userData?.id,
                setError: (e) => {

                    dispatch(setToast({ severity: "error", detail: "error" } as ToastMessage))
                    setBlock(false);
                },
                effectProcess: [(res) => {

                    if (res?.success === false) {
                        dispatch(setToast({ severity: "error", detail: gW(res?.message || "happen-error") } as ToastMessage))
                    } else {
                        effect?.();
                        setSelectThreeItem(null);
                        sceneItemsRef.current?.scene_group?.remove?.(mesh);
                    }

                    setBlock(false);

                }]
            });
        } else {
            sceneItemsRef.current?.scene_group?.remove?.(mesh);
            setSelectThreeItem(null);
            effect?.();
        }


    }



    const values: MapEditorContextProps = {
        // cards,setCards,
        addMesh,
        // setMeshes,
        handleSave,
        handleUpdate,
        handleDelete,

        // category,setCategory,
        // deletedMeshes,setDeletedMeshes,
        selectThreeItem,
        setSelectThreeItem,
        sceneItemsRef,
        handleLoadScene,
        getActiveThreeItems,
        loadMapItems,
        setActiveThreeItems,
        activeThreeItems,
        getMeshesOfBuilding,
        getItemsOfMap,
        threeItems,
        setThreeItems,
        loadMeshes,
        mapEditorId:mapEditorId||undefined

        // materials,
        // setMaterials
    }

    return (<MapEditorContext.Provider value={values}>
        {/* {alert&&<Alert color={alert.color} open={alert!==null} onClose={()=>setAlert(null)}  messages={[<p key={1} > {alert.message} </p>]} />} */}
        {props.children}
        {/* {block&&<Loading/>} */}
    </MapEditorContext.Provider>)
}



export const useMapEditorContext = () => useContext<MapEditorContextProps>(MapEditorContext);